import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { BadgeSize, BadgeTheme, Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { IconContainerProps, LabelContainerProps } from './circleBadges.types';

const IconContainerStyles: { [b in BadgeSize]: FlattenSimpleInterpolation } = {
  [BadgeSize.Small]: css`
    margin-right: 12px;
    width: 40px;
    height: 40px;
  `,
  [BadgeSize.Medium]: css`
    margin-right: 16px;
    width: 56px;
    height: 56px;
  `,
};

const LabelContainerStyles: { [b in BadgeSize]: FlattenSimpleInterpolation } = {
  [BadgeSize.Small]: css`
    font-size: 16px;
    line-height: 22px;
  `,
  [BadgeSize.Medium]: css`
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.01em;

    @media ${Breakpoint.SmallMobile} {
      font-size: 18px;
      line-height: 26px;
    }
  `,
};

export const Container: StyledComponent<'div'> = styled.div`
  width: fit-content;
`;

export const BadgeContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 12px;
  }
`;

export const IconContainer: StyledComponent<'div', IconContainerProps> = styled.div<IconContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $theme }: IconContainerProps): string => $theme === BadgeTheme.Gray ? Color.Gray200 : Color.Transparent};
  border: ${({ $theme }: IconContainerProps): string => $theme === BadgeTheme.Gray ? 'none' : `1px solid ${Color.Gray300}`};
  border-radius: 50%;
  flex-shrink: 0;
  ${({ $size }: IconContainerProps): FlattenSimpleInterpolation => IconContainerStyles[$size as BadgeSize]};

  @media ${Breakpoint.SmallMobile} {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
`;

export const LabelContainer: StyledComponent<'div', LabelContainerProps> = styled.div<LabelContainerProps>`
  font-weight: ${FontWeight.Light};
  color: ${Color.Black};
  ${({ $size }: LabelContainerProps): FlattenSimpleInterpolation => LabelContainerStyles[$size as BadgeSize]};
`;
